export default {
    computed: {
       subscriptions() {return this.$store.getters.getCurrentSubscriptions }
    }
}